import { render, staticRenderFns } from "./AIAgent.MessageConfirm.vue?vue&type=template&id=3ba53935&lang=pug"
import script from "./AIAgent.MessageConfirm.vue?vue&type=script&lang=js"
export * from "./AIAgent.MessageConfirm.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.MessageConfirm.vue?vue&type=style&index=0&id=3ba53935&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports